//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';
import { ChatMessage } from '../components/Loops/AI/AIModule';

interface AIModuleContextType {
  isAIModuleVisible: boolean;
  setIsAIModuleVisible: (visible: boolean) => void;
  chatHistories: Record<string, ChatMessage[]>;
  setChatHistories: Dispatch<SetStateAction<Record<string, ChatMessage[]>>>;
}

const AIModuleContext = createContext<AIModuleContextType | undefined>(
  undefined,
);

export function AIModuleProvider({ children }: { children: ReactNode }) {
  const [isAIModuleVisible, setIsAIModuleVisible] = useState(false);
  const [chatHistories, setChatHistories] = useState<
    Record<string, ChatMessage[]>
  >({});

  return (
    <AIModuleContext.Provider
      value={{
        isAIModuleVisible,
        setIsAIModuleVisible,
        chatHistories,
        setChatHistories,
      }}
    >
      {children}
    </AIModuleContext.Provider>
  );
}

export function useAIModule() {
  const context = useContext(AIModuleContext);
  if (context === undefined) {
    throw new Error('useAIModule must be used within an AIModuleProvider');
  }
  return context;
}
